
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(200|239|831|89)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
